import { PathHistoryType } from "@/contexts/route-history-context/route-history-types";
const PATH_HISTORY_KEY = 'pathHistory';

const getInitialHistory = (): PathHistoryType => {
    try {
        const isSent = localStorage.getItem('is-sent');
        const sentGiftString = localStorage.getItem('sent-gift');
        const sentGift = sentGiftString ? JSON.parse(sentGiftString) : null;

        if (isSent && sentGift) {
            return { 
                currentPath: `/redeem-gift/${sentGift.contract_address}`, 
                lastPath: null 
            };
        }

        const savedHistory = window.localStorage.getItem(PATH_HISTORY_KEY);
        return savedHistory ? JSON.parse(savedHistory) : { currentPath: '', lastPath: null };
    } catch (error) {
        console.error(error);
        return { currentPath: '/home', lastPath: null };
    }
};

const setRouteHistory = (newData: PathHistoryType): void => {
    try {
        const serializedData = JSON.stringify(newData);
        window.localStorage.setItem(PATH_HISTORY_KEY, serializedData);
    } catch (error) {
        console.error(error);
    }
};

const getRouteHistory = (): PathHistoryType => {
    return getInitialHistory();
};

const removeRouteHistory = (): void => {
    try {
        window.localStorage.removeItem(PATH_HISTORY_KEY)
    } catch (error) {
        console.error(error);
    }
};

export {
    getInitialHistory,
    setRouteHistory,
    getRouteHistory,
    removeRouteHistory
};
